import { useState } from 'react';
import { AppImages } from '../assets/s3';
import NavBar from '../components/navbar';
import clsx from 'clsx';
import { redirect } from '../util';
import { RedirectURLs } from '../constants/redirectURLS';

export default function ActivateCard() {
  const [selectedView, setSelectedView] = useState(0);
  const dApp = [
    {
      title: 'Step 1',
      description: 'Click on the activate your physical card button',
      images: [AppImages.Activate_CARD_STEP1],
    },
    {
      title: 'Step 2',
      description: 'Enter the last 4 digits of the physical card',
      images: [AppImages.Activate_CARD_STEP2],
    },
    {
      title: 'Step 3',
      description: 'Enter the OTP sent to the registered email and phone',
      images: [AppImages.Activate_CARD_STEP3],
    },
    {
      title: 'Step 4',
      description: 'Physical card gets activated',
      images: [AppImages.Activate_CARD_STEP4],
    },
    {
      title: 'Step 5',
      description: 'Click on the settings icon on the card to set pin',
      images: [AppImages.Activate_CARD_STEP5],
    },
    {
      title: 'Step 6',
      description: 'Type the pin along with the OTP to set it',
      images: [AppImages.Activate_CARD_STEP6, AppImages.Activate_CARD_STEP7],
    },
  ];
  const mobile = [
    {
      title: 'Step 1',
      description: 'Click on the activate your physical card button',
      images: [AppImages.MOBILE_Activate_CARD_STEP1],
    },
    {
      title: 'Step 2',
      description: 'Enter the last 4 digits of the physical card',
      images: [AppImages.MOBILE_Activate_CARD_STEP2],
    },
    {
      title: 'Step 3',
      description: 'Enter the OTP sent to the registered email and phone',
      images: [AppImages.MOBILE_Activate_CARD_STEP3],
    },
    {
      title: 'Step 4',
      description: 'Physical card gets activated',
      images: [AppImages.MOBILE_Activate_CARD_STEP4],
    },
    {
      title: 'Step 5',
      description:
        'Click on the settings icon on the card and select Set New Pin option to set pin for your card.',
      images: [
        AppImages.MOBILE_Activate_CARD_STEP5_1,
        AppImages.MOBILE_Activate_CARD_STEP5_2,
      ],
    },
    {
      title: 'Step 6',
      description: 'Enter the pin you wnat to set for your card',
      images: [AppImages.MOBILE_Activate_CARD_STEP6],
    },
    {
      title: 'Step 7',
      description: 'Type the OTP to set pin for your card.',
      images: [
        AppImages.MOBILE_Activate_CARD_STEP7_1,
        AppImages.MOBILE_Activate_CARD_STEP7_2,
      ],
    },
  ];
  const instructions = !selectedView ? dApp : mobile;
  return (
    <div class='flex flex-col justify-center items-center'>
      <div className='pt-5'>
        <NavBar />
      </div>
      <h1 class='font-bold text-[32px] mt-24 text-center'>
        How To Activate Cypher Card
      </h1>
      <img
        src={AppImages.Activate_CARD_BANNER}
        alt=''
        class='mt-12'
      />
      <div class='flex flex-row justify-center items-center border-[2px] border-appBg rounded-xl mt-12'>
        <div
          class={clsx(
            'text-center font-semibold cursor-pointer py-2 px-8 rounded-l-md',
            {
              'bg-appBg': !selectedView,
            }
          )}
          onClick={() => setSelectedView(0)}
        >
          DApp
        </div>
        <div
          class={clsx(
            'text-center font-semibold cursor-pointer py-2 px-8 rounded-r-md',
            {
              'bg-appBg': selectedView,
            }
          )}
          onClick={() => setSelectedView(1)}
        >
          Mobile App
        </div>
      </div>
      <div class='flex flex-col justify-center items-center self-center w-[85%] lg:w-[65%]'>
        {instructions.map((item, index) => {
          return (
            <div class={clsx('mt-8 lg:w-[70%]')}>
              <div class='ml-1'>
                <h1 class='font-semibold text-[18px]'>{item.title}</h1>
                <h4 class='mt-1 text-sm lg:text-[16px]'>{item.description}</h4>
              </div>
              <div
                class={clsx('self-center', {
                  'flex flex-row justify-center items-center w-full':
                    selectedView,
                })}
              >
                {item.images.map((image) => {
                  return (
                    <img
                      src={image}
                      alt=''
                      class={clsx('mt-2', { 'w-[40%]': selectedView })}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div class='flex flex-col justify-center items-center mt-16 mb-8 w-[90%] lg:w-[65%]'>
        <img
          src={AppImages.THATS_IT}
          alt=''
        />
        <p class='mt-4 lg:text-[20px] text-center'>
          you can activate your card and set the pin in{' '}
          {!selectedView ? 'six' : 'seven'} simple steps.
        </p>
        <button
          onClick={() => redirect(RedirectURLs.dApp)}
          class='bg-appBg px-8 py-4 font-semibold rounded-md mt-6'
        >
          Activate Your Card Now
        </button>
      </div>
    </div>
  );
}
